import { render, staticRenderFns } from "./showCard.vue?vue&type=template&id=162b8d03&scoped=true"
import script from "./showCard.vue?vue&type=script&lang=js"
export * from "./showCard.vue?vue&type=script&lang=js"
import style0 from "./showCard.vue?vue&type=style&index=0&id=162b8d03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162b8d03",
  null
  
)

export default component.exports